"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.hoverSeries = hoverSeries;
exports.hoverDatum = hoverDatum;
exports.selectSeries = selectSeries;
exports.selectDatum = selectDatum;
function hoverSeries(series) {
  this.props.dispatch(function (state) {
    return _extends({}, state, {
      hovered: series ? {
        active: true,
        series: series,
        datums: [],
        single: false
      } : _extends({}, state.hovered, {
        active: false
      })
    });
  });
}

function hoverDatum(datum) {
  this.props.dispatch(function (state) {
    return _extends({}, state, {
      hovered: datum ? {
        active: true,
        series: null,
        datums: [datum],
        single: true
      } : _extends({}, state.hovered, {
        active: false
      })
    });
  });
}

function selectSeries(series) {
  this.props.dispatch(function (state) {
    return _extends({}, state, {
      selected: series ? {
        active: true,
        series: series,
        datums: [],
        single: false
      } : {
        active: false
      }
    });
  });
}

function selectDatum(datum) {
  this.props.dispatch(function (state) {
    return _extends({}, state, {
      selected: datum ? {
        active: true,
        series: null,
        datums: [datum],
        single: true
      } : {
        active: false
      }
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-charts/es/utils/interactionMethods.js
// module id = 161
// module chunks = 0